import {Chart} from './chart';
import {Rect} from '@/types/primitives';
import {Constants as constants} from '../config/constants';

export class LogoRenderer {
    private groupRect = null as unknown as Rect;

    constructor(private chart: Chart) {
    }

    public render() {
        this.calculateGroupRect();
        this.renderLegalDescription();

        this.calculateGroupRect();
        this.renderLogo();
    }

    private calculateGroupRect() {
        const groupSize = this.chart.node.group.node().getBBox();
        this.groupRect = {
            left: groupSize.x,
            top: groupSize.y,
            right: groupSize.x + groupSize.width,
            bottom: groupSize.y + groupSize.height
        };
    }

    private renderLegalDescription() {
        const size = {
            w: this.groupRect.right - this.groupRect.left,
            h: 75
        };

        const foreignContainer = this.chart.node.group
            .append('foreignObject')
            .attr('height', size.h)
            .attr('width', size.w)
            .attr('transform', `translate(${this.chart.toolList.pathRenderer.data.center.x - size.w / 2}, ${this.groupRect.bottom})`);

        const paragraphContainer = foreignContainer
            .append('xhtml:div')
            .attr('class', 'paragraph-container');

        constants.legalDescriptionText.map((paragraph) => {
            paragraphContainer
                .append('xhtml:div')
                .text(paragraph)
                .attr('class', 'legal-paragraph');
        });

        foreignContainer
            .attr('height', (paragraphContainer.node() as HTMLDivElement).clientHeight + constants.legalDescriptionPadding);
    }

    private renderLogo() {
        const position = {
            x: this.groupRect.right + constants.legalDescriptionPadding * 18,
            y: this.groupRect.top
        };
        const textTransform = {
            x: 0,
            y: 100
        };

        const logoContainer = this.chart.node.group
            .append('g');

        constants.logoText.map((logo) => {
            const logoInstance = logoContainer
                .append('text')
                .text(logo)
                .attr('class', 'logo');

            logoInstance
                .attr('transform', `translate(${textTransform.x}, ${textTransform.y})`);

            textTransform.y += (logoInstance.node() as SVGTextElement).getBBox().height - constants.logoPaddingNormalizationValue;
        });

        logoContainer
            .attr('transform', `translate(${position.x}, ${position.y - (logoContainer.node() as SVGGElement).getBBox().height / 4})`);
    }
}
